import clsx, { type ClassValue } from 'clsx';

/**
 * Class names for design-system primitives: semantic tokens and utilities first,
 * then optional `className` so callers can extend or override (last wins in the merged string).
 */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
